// TODO! SPLIT IT UP
import type { ResourceGroup } from "@@/shared/acquire/resources/resource-group";
import type { ResourceLocal } from "@@/shared/acquire/resources/resource-local";
import type { ResourceShared } from "@@/shared/acquire/resources/resource-shared";
import type { MinMaxRange } from "@@/utilities/set-within-range";
import type { Except } from "type-fest";
import { z } from "zod";
import type { IsoAndUnixTimestamp } from "../../date-time/iso-and-unix";
import { nowIsoAndUnix } from "../../date-time/iso-and-unix";
import type { MetaContent } from "../../meta-content/meta-content";
import type { BookableOption } from "../resource-reference-options/bookable-option";
import type { ResourceReferenceId } from "./resource-reference-id";
import { resourceReferenceIdFactory } from "./resource-reference-id";
import type { ResourceSchedule } from "./schedule/resource-schedule";
type ResourcePickerEnabled =
    | "NEVER"
    | "PROVIDER"
    | "ALWAYS"
    | "LIMIT_FOR_CUSTOMER";
const resourcePickerEnabledZodSchema = z.enum([
    "NEVER",
    "PROVIDER",
    "ALWAYS",
    "LIMIT_FOR_CUSTOMER",
]);

/**
 * Antalgrupp
 *
 */
type ResourceReference = {
    readonly _id: ResourceReferenceId;
    readonly _type: "RESOURCE_REFERENCE";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly meta: MetaContent;
    readonly resource: ResourceLocal | ResourceShared | ResourceGroup; //Resource;
    readonly options: BookableOption[];
    readonly schedulingResource?: ResourceSchedule;
    readonly resourcePickerEnabled?: ResourcePickerEnabled;
    readonly minMax?: MinMaxRange;
    readonly displayResourceTitle?: boolean;
};

const resourceReferenceFactory = (
    params: Except<ResourceReference, "_id" | "_type" | "_createdAt"> & {
        _id?: ResourceReferenceId;
    },
): ResourceReference => {
    return {
        ...params,
        _id: params._id ?? resourceReferenceIdFactory(),
        _type: "RESOURCE_REFERENCE",
        _createdAt: nowIsoAndUnix(),
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isResourceReference = (input: any): input is ResourceReference => {
    return input?._type === "RESOURCE_REFERENCE";
};

export {
    isResourceReference,
    resourcePickerEnabledZodSchema,
    resourceReferenceFactory,
};
export type { ResourcePickerEnabled, ResourceReference };
